module.exports = __webpack_public_path__ + "img/black.9adf13e0.png";